const generateStyle = componentTheme => {
  const mp = '@media print'
  return {
    content: {
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      '&:focus': {
        borderColor: componentTheme.focusBorderColor,
        outline: `0.1875rem solid ${componentTheme.focusOutlineColor}`,
        outlineOffset: '-0.1875rem',
        boxShadow: 'initial',
      },
      [mp]: {
        overflow: 'unset',
      },
    },
  }
}

export default generateStyle
